import React from "react";
import { ShimmerSimpleGallery } from "react-shimmer-effects";

const ReviewDashboardShimmer = () => {
  return (
    <>
      <div className="mb_20">
        <ShimmerSimpleGallery card imageHeight={100} row={1} col={3} />
      </div>
      <div className="mb_20">
        <ShimmerSimpleGallery card imageHeight={450} row={1} col={1} />
      </div>

      <div className="mb_20">
        <div className="d-flex gap-4">
          <ShimmerSimpleGallery card imageHeight={290} row={1} col={1} />
          <ShimmerSimpleGallery card imageHeight={290} row={1} col={1} />
        </div>
      </div>
      <div className="mb_20">
        <ShimmerSimpleGallery card imageHeight={290} row={1} col={1} />
      </div>
    </>
  );
};

export default ReviewDashboardShimmer;
